var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-circle-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9997 36.6668C10.7949 36.6668 3.33301 29.2048 3.33301 20.0002C3.33301 10.7954 10.7949 3.3335 19.9997 3.3335C29.2043 3.3335 36.6663 10.7954 36.6663 20.0002C36.6663 29.2048 29.2043 36.6668 19.9997 36.6668ZM19.9997 17.6432L15.2856 12.9291L12.9286 15.2861L17.6427 20.0002L12.9286 24.7142L15.2856 27.0712L19.9997 22.3572L24.7137 27.0712L27.0707 24.7142L22.3567 20.0002L27.0707 15.2861L24.7137 12.9291L19.9997 17.6432Z",
    fill: "#EA4B8B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleFill);
export default __webpack_public_path__ + "static/media/close-circle-fill.8dc9cda9ef30b4b11bc368ed81b90fec.svg";
export { ForwardRef as ReactComponent };